// Helpers do módulo financeiro — PORTADO do StormFin (apps/web/src/lib/utils.ts).
// Formatação pt-BR (milhar "." / decimal ",") + label maps. Cópia fiel.

export function fmt(value: number, currency = "€"): string {
  return (
    currency +
    " " +
    Math.abs(value).toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
}

export function fmtSigned(value: number, currency = "€"): string {
  const s = Math.abs(value).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return (value >= 0 ? "+" : "-") + currency + " " + s;
}

export const TIPO_LABELS: Record<string, string> = {
  pending: "Pendente",
  revenue: "Receita",
  operational_cost: "Custo operac.",
  company_expense: "Despesa empresa",
  distribution: "Distribuição",
  internal_transfer: "Transf. interna",
};

export const COMPANY_OPTS = [
  { value: "BR Storms", label: "BR Storms" },
  { value: "Euro Storm", label: "Euro Storm" },
  { value: "Geral", label: "Geral" },
] as const;

export const ACCOUNT_OPTS = [
  { value: "Neto", label: "Neto" },
  { value: "Landione", label: "Landione" },
  { value: "Despesas", label: "Despesas" },
  { value: "Pagar Técnico", label: "Pagar Técnico" },
  { value: "TVA", label: "TVA" },
] as const;

export const TYPE_OPTS = [
  { value: "pending", label: "Pendente" },
  { value: "revenue", label: "Receita" },
  { value: "operational_cost", label: "Custo operacional" },
  { value: "company_expense", label: "Despesa empresa" },
  { value: "distribution", label: "Distribuição" },
  { value: "internal_transfer", label: "Transf. interna" },
] as const;
